// extracted by mini-css-extract-plugin
export default {"container":"LoadSpinner_container__5Kspr","spinner":"LoadSpinner_spinner__BFAs9","spin":"LoadSpinner_spin__bYM+R"};